export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20curation%20scene%20with%20neatly%20arranged%20clothing%20pieces%20in%20warm%20sand%20cream%20and%20taupe%20tones%20on%20a%20light%20oak%20surface%2C%20soft%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20editorial%20lifestyle%20photography%20with%20organic%20textures%20and%20gentle%20shadows%2C%20airy%20minimalist%20composition%20with%20negative%20space%2C%20warm%20inviting%20atmosphere&width=1440&height=900&seq=hero-sugargoo-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion product curation lifestyle photography"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-sparkling-2-line text-sm text-accent-300"></i>
          </span>
          <span className="text-xs font-medium text-background-50/90 whitespace-nowrap">Updated 2026 Resources</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight tracking-tight">
          The Ultimate{' '}
          <span className="text-primary-300">Sugargoo Spreadsheet</span>
          {' '}Resource Hub
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-background-50/80 max-w-2xl mx-auto leading-relaxed">
          Discover curated Sugargoo spreadsheets, trending product collections, shopping guides, and expert tips to make international shopping effortless and rewarding.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            Sugargoo Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-6">
          <div className="flex items-center gap-1.5 text-background-50/70 text-xs">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-check-line text-primary-300 text-sm"></i>
            </span>
            Updated Resources
          </div>
          <div className="flex items-center gap-1.5 text-background-50/70 text-xs">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-check-line text-primary-300 text-sm"></i>
            </span>
            Buyer Guides
          </div>
          <div className="flex items-center gap-1.5 text-background-50/70 text-xs">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-check-line text-primary-300 text-sm"></i>
            </span>
            Shipping Information
          </div>
          <div className="flex items-center gap-1.5 text-background-50/70 text-xs">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-check-line text-primary-300 text-sm"></i>
            </span>
            Safety Verified
          </div>
        </div>
      </div>
    </section>
  );
}